import { Injectable, signal } from '@angular/core';

export type AuthError = 'forbidden' | 'unauthorized' | null;

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  readonly authError = signal<AuthError>(null);

  get forbidden(): boolean {
    return this.authError() === 'forbidden';
  }

  setForbidden(): void {
    this.authError.set('forbidden');
  }

  setUnauthorized(): void {
    this.authError.set('unauthorized');
  }

  clearError(): void {
    this.authError.set(null);
  }
}
